<link rel="stylesheet" href="//use.fontawesome.com/releases/v5.0.7/css/all.css">
<script src="https://use.fontawesome.com/29ecae9da7.js"></script>

<div class="edit-address" >
     <div class="address-left" >
        
        <h1 style="font-size: 24px;">MY ACCOUNT</h1>
        <li>Account information</li>
        <a class="order" >My Orders</a>
        <a class="logout" >Log out</a>
     </div><!--end left-->

     <div class="vl" ></div>

     <div class="address-right" >
        <p>Shipping address</p>
        <form name="addressform">
        <input type="text" class="inputbox" name="adress1" placeholder="Address line 1"><br>
        <input type="text" class="inputbox" name="adress1" placeholder="Address line 2"><br>
        <input type="text" class="inputbox" name="adress1" placeholder="City*"><br>
        <input type="text" class="inputbox" name="adress1" placeholder="State*"><br>
        <input type="text" class="inputbox-postal" name="adress1" placeholder="Postal code*"><br>
        <p>Would you like to Label your address</p>
        <p class="icon-p" ><i class="bx bx-home" ></i>Home</p>
        <p class="icon-p" ><i class="bx bx-briefcase"></i>Work</p><br>
        <button type="submit" onclick="validateForm()" >Save address</button>
        </form>
     </div><!--end right-->
</div><!--end edit address-->

<script>
   function validateForm() {
     var x = document.forms["addressform"]["adress1"].value;
     if (x == "") {
       alert("Name must be filled out");
       return false;
     }
   }
</script>